import Vue from 'vue'
import VueScrollStop from 'vue-scroll-stop'
import VueTouch from 'vue2-touch-events'
import App from './App.vue'
import VueCarousel from 'vue-carousel'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueScrollStop)
Vue.use(VueTouch)
Vue.use(VueCarousel)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
